//获取两个日期间的全部日期
function getdiffdate(stime, etime) {
	//初始化日期列表，数组
	var diffdate = new Array();
	//开始日期小于等于结束日期,并循环
	console.log(stime, etime)
	while (new Date(etime) > new Date(stime)) {
		diffdate.push(stime)
		//获取开始日期时间戳
		var stime_ts = new Date(stime).getTime();
		// console.log('当前日期：' + stime + '当前时间戳：' + stime_ts);

		//增加一天时间戳后的日期
		var next_date = stime_ts + (24 * 60 * 60 * 1000);

		//拼接年月日，这里的月份会返回（0-11），所以要+1
		var next_dates_y = new Date(next_date).getFullYear() + '-';
		var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) +
			'-' : (new Date(next_date).getMonth() + 1) + '-';
		var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(
			next_date).getDate();

		stime = next_dates_y + next_dates_m + next_dates_d;
	}
	
	diffdate.push(etime)
	return diffdate;
}

function formatDate1(date) {
	return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

function formatDate(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
		}
	}
	return fmt
}

function padLeftZero(str) {
	return ('00' + str).substr(str.length)
}

function formatDateMy(date, fmt) {
	var o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"h+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"S": date.getMilliseconds() //毫秒
	};
	console.log(o)
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
		}
	}
	return fmt
}

function getDatenow(fmt) {
	var ddnow = new Date();
	let retdate = formatDate(ddnow, fmt);
	return retdate;
	// var yy = ddnow.getFullYear();
	// var mm = ddnow.getMonth() + 1; //获取当前月份的日期
	// var dd = ddnow.getDate();
	// mm = String(mm < 10 ? '0' + mm : mm);
	// dd = String(dd < 10 ? '0' + dd : dd);
	// let end = yy + "-" + mm + "-" + dd;
}

function GetDateStr(AddDayCount, fmt) {
	var day = new Date();
	day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
	let retdate = formatDate(day, fmt);
	return retdate;
	// var y = day.getFullYear();
	// var m = day.getMonth() + 1; //获取当前月份的日期
	// var d = day.getDate();
	// m = String(m < 10 ? '0' + m : m);
	// d = String(d < 10 ? '0' + d : d);
	// let beg = y + "-" + m + "-" + d;

	// return  y + "-" + m + "-" + d;
}
export {
	getdiffdate,
	formatDate,
	getDatenow,
	GetDateStr
}
